import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuickTimes, QuickTimeRec, QuickTimeInp } from 'src/models';
import { BlankQuickTimeRec, BlankQuickTimes } from 'src/models/QuickTimes/TestQuickTimes';
import { IStoreState } from 'src/store';
import { ViewMode } from 'src/enums';
import * as acBase from 'src/store/states/GenericActionCreator';

/** Interfaces */
export interface IQuickTimesState {
    quickTimes: QuickTimes;
    qtimeSlots: QuickTimeRec[];
    lastDeptRan: string;
    recallFlagUsed?: boolean;
    error?: string | undefined;
}

/** Initial State */
export const initialState: IQuickTimesState = {
    quickTimes: BlankQuickTimes,
    qtimeSlots: BlankQuickTimeRec,
    lastDeptRan: '',
    // recallFlagUsed: '',
};

export const QuickTimesSlice = createSlice({
    name: 'QuickTimes',
    initialState: initialState as IQuickTimesState,
    reducers: {
        getQuickTimes: (state, action: PayloadAction<IQuickTimesState>) => {
            state.qtimeSlots = action.payload.qtimeSlots;
            state.quickTimes = action.payload.quickTimes;
            state.lastDeptRan = action.payload.lastDeptRan;
            state.recallFlagUsed = action.payload.recallFlagUsed;
        },
        setQuickTimesError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
        },
        // clearQuickTimes: (state, action: PayloadAction<IQuickTimesState>) => {
        //     state.qtimeSlots = action.payload.qtimeSlots;
        //     state.quickTimes = action.payload.quickTimes;
        //     state.lastDeptRan = action.payload.lastDeptRan;
        //     state.recallFlagUsed = undefined;
        // },
    },
});

export const {
    getQuickTimes,
    setQuickTimesError,
} = QuickTimesSlice.actions;

export default QuickTimesSlice.reducer;

export function GetQuickTimes(inp: QuickTimeInp) {
    return async (dispatch, getState: () => IStoreState) => {
        const CurrAppt = { ...getState().Appointment.Appointment };
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const apptOps = getState().Appointment.ApptOps.map(op => op.operation);
        const logId = getState().Framework.logId;
        const menus = getState().Menus;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }

        const maintMenuSelections: string[] = [];
        if (menus.checkedMileageMenu) {
            const mileageEraOpcode = menus.allMenus.menus.find(menu => (menu.id === menus.checkedMileageMenu))?.eraOpCode;
            if (mileageEraOpcode) {
                maintMenuSelections.push(mileageEraOpcode);
            }
        }
        if (menus.checkedConditionalMenus) {
            menus.checkedConditionalMenus.forEach(condMenu => {
                const condEraOp = menus.allMenus.menus.find(menu => (menu.id === condMenu.id));
                if (condEraOp?.eraOpCode) {
                    maintMenuSelections.push(condEraOp.eraOpCode);
                }
            });
        }
        // for each apptOp that is null or undefined replace it with a WYO marker
        // for each apptOp that is CMENU or MMENU replace it with a mapped opcode
        apptOps.forEach((op) => {
            if (op === null || op === undefined) {
                apptOps[apptOps.indexOf(op)] = 'WYO';
            }
            if (op === 'MMENU' || op === 'CMENU') {
                if (maintMenuSelections.length > 0) {
                    apptOps[apptOps.indexOf(op)] = maintMenuSelections.pop()!;
                }
            }
        });

        const reqData = {
            profileNum: inp.specProfile,
            dept: CurrAppt.department,
            lastAdv: inp.lastAdv,
            lastTrans: inp.lastTrans,
            recallSelected: inp.recallSelected,
            apptOps: apptOps,
            logId: logId,
            callingProgram: callingProgram,
        };

        let response = await acBase.eraWebServiceCall<QuickTimeRec[] | string>(
            'SVPController', 'QuickTimes', reqData, store, branch);

        if (response === null) {
            response = [];
        }
        if (response.returnCode && response.returnCode === '8000') {
            dispatch(setQuickTimesError(response.returnCode));
        } else {
            const quickTest = {
                lastAdvNum: '999',
                lastAdvName: 'Tracy Keyton',
                lastTransType: '',
                BuiltTime: Date.parse(Date()),
                Built: true,
                RC: '',
            };

            const times: IQuickTimesState = {
                qtimeSlots: response ?? [],
                quickTimes: quickTest,
                lastDeptRan: CurrAppt.department,
                recallFlagUsed: inp.recallSelected,
            };

            dispatch(getQuickTimes(times));
        }
    };
}

export function ClearQuickTimes() {
    return (dispatch) => {
        const times: IQuickTimesState = {
            quickTimes: BlankQuickTimes,
            qtimeSlots: BlankQuickTimeRec,
            lastDeptRan: '',
        };
        dispatch(getQuickTimes(times));
    };
}